import styled from 'styled-components';

import { AnimatedIconContainer } from 'components/AnimatedIcon/AnimatedIcon.styled';
import { ButtonWrapper } from 'components/Button/Button.styled';
import { transition } from 'theme/theme';

export const CmsReactionButtonContainer = styled.div`
  width: 120px;

  ${ButtonWrapper} {
    gap: 12px;
  }

  ${AnimatedIconContainer} {
    transform: scale(1.4);
  }

  &[data-qa-reaction-status='INSPIRED'] {
    ${AnimatedIconContainer} {
      position: relative;
      top: 2px;
      left: 2px;
    }
  }
`;

export const CmsReactionTooltipContainer = styled.div`
  display: flex;
  gap: 7px;
  padding: 10px;
`;

export const CmsReactionTooltipIcon = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  height: 37px;
  justify-content: center;
  width: 37px;
  transition: transform ${transition};

  &:nth-child(1) {
    transform-origin: right;
  }

  &:nth-child(2) {
    transform-origin: center;
  }

  &:nth-child(3) {
    transform-origin: left;
  }

  &:hover {
    transform: scale(1.4) translateY(-10px);
  }
`;
